import BossModel from "@/models/BossModel";

export default class Transcription extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = "phone-call/transcription";

    /**
     *
     * @type {string}
     */
    static entity = "phoneCallTranscriptions";

    static fields() {
        return {
            id: this.attr(null),
            phone_call_id: this.number(null),
            transcription: this.attr([]),
            created_at: this.attr(null),
            status: this.attr(null),
            summary: this.attr(null),
            summary_review: this.attr(null),
            summary_status: this.attr(null),
        };
    }
}
